import script from "./InputPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputPhone.vue?vue&type=script&setup=true&lang=ts"

import "./InputPhone.vue?vue&type=style&index=0&id=396bced6&lang=scss"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QInput});
